import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { FC, useMemo } from 'react'
import onlyAllowedAndLatinLetters from 'utils/onlyAllowedAndLatinLetters'

import { CheckMarkIcon, TimesIcon } from 'components/Images/Icons'

import styles from './ValidationPointsList.module.scss'

interface IValidationPointProps {
  text: string
  success: boolean
}

const ValidationPoint: FC<IValidationPointProps> = (props) => {
  const { text, success } = props

  return (
    <div className={classNames(styles.wrapper, { [styles.success]: success })}>
      <div className={styles.icon}>{success ? <CheckMarkIcon /> : <TimesIcon />}</div>
      <span className={styles.text}>{text}</span>
    </div>
  )
}

const ValidationPointsList = ({ t }) => {
  const { values } = useFormikContext<{ newPassword: string; confirmPassword: string }>()
  const { newPassword: password, confirmPassword } = values
  const validationPoints = useMemo(
    () => [
      {
        text: t(`main:eightChars`),
        success: password?.length >= 8 && password?.length <= 32,
      },
      {
        text: t(`main:oneNum`),

        success: /[0-9]/.test(password),
      },
      {
        text: t(`main:specialChar`),
        success: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~№]/.test(password),
      },
      {
        text: t(`main:noLeading`),
        success: !password?.includes(' ') && password?.length > 0,
      },
      {
        text: t(`main:lowerAndUpper`),
        success: /[A-Z]/.test(password) && /[a-z]/.test(password),
      },
      {
        text: t(`main:nonLatin`),
        success: onlyAllowedAndLatinLetters(password),
      },
      {
        text: t(`error:paswordRepeated`),
        success: confirmPassword === password && password?.length > 0,
      },
    ],
    [password, confirmPassword, t],
  )

  const requirementsMet = useMemo(
    () => validationPoints.every(({ success }) => success),
    [validationPoints],
  )

  return (
    <div className={styles.pointsWrapper}>
      <span
        className={classNames(styles.error, {
          [styles.successText]: requirementsMet,
        })}
      >
        {requirementsMet ? t(`main:reqMet`) : t(`main:noReqMet`)}
      </span>
      <div className={styles.validationPoints}>
        {validationPoints.map(({ text, success }) => (
          <ValidationPoint key={text} text={text} success={success} />
        ))}
      </div>
    </div>
  )
}
export default ValidationPointsList
